import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";

class SearchBox extends Component {
  state = {
    search: ""
  };

  handleSearch = search => {
    if (search.charAt(0) !== " ") {
      const { getSearchInputData, searchPageType, getInputValue } = this.props;
      if (searchPageType === "filterSearch") {
        this.setState({ search });
        getInputValue(search);
      } else {
        this.setState({ search }, () => {
          const timeout = setTimeout(() => {
            getSearchInputData(search);
            clearTimeout(timeout);
          }, 10);
        });
      }
    }
  };

  onBlurHandler = () => {
    this.setState({ search: "" });
  };

  render() {
    const { search } = this.state;
    return (
      <Form onSubmit={this.handleSearch}>
        <Form.Group className="search-box">
          <Form.Control
            type="text"
            placeholder="Search"
            onChange={e => {
              this.handleSearch(e.target.value);
            }}
            value={search}
            onBlur={this.onBlurHandler}
          />
        </Form.Group>
      </Form>
    );
  }
}

SearchBox.propTypes = {
  getSearchInputData: PropTypes.func,
  searchPageType: PropTypes.string
};
SearchBox.defaultProps = {
  getSearchInputData: () => {},
  searchPageType: ""
};
export default SearchBox;
